export const setInLocalStorage = (key, object) => {
    const objectAsString = JSON.stringify(object);
    localStorage.setItem(key, objectAsString);
}

export const getInLocalStorage = (key) => {
    let value = localStorage.getItem(key);

    if (!value) {
        return undefined;
    }

    return JSON.parse(value);
}

export const removeInLocalStorage = key => localStorage.removeItem(key);